module.exports = __webpack_public_path__ + "static/media/add-image.9359d1c8.svg";